var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 61,
    viewBox: "0 0 180 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.36719C0 2.60576 2.23858 0.367188 5 0.367188H175C177.761 0.367188 180 2.60576 180 5.36719V55.4526C180 58.2141 177.761 60.4526 175 60.4526H5C2.23858 60.4526 0 58.2141 0 55.4526V5.36719Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.848 33.0407C87.712 33.0407 85.156 35.728 85.156 39.4292C85.156 43.108 87.712 45.8178 90.848 45.8178C93.9853 45.8178 96.5413 43.108 96.5413 39.4292C96.54 35.728 93.984 33.0407 90.848 33.0407ZM90.848 43.3033C89.1293 43.3033 87.648 41.7065 87.648 39.4307C87.648 37.131 89.1307 35.5582 90.848 35.5582C92.5667 35.5582 94.048 37.131 94.048 39.4307C94.048 41.705 92.5667 43.3033 90.848 43.3033ZM78.4293 33.0407C75.2933 33.0407 72.7373 35.728 72.7373 39.4292C72.7373 43.108 75.2933 45.8178 78.4293 45.8178C81.5667 45.8178 84.1227 43.108 84.1227 39.4292C84.1227 35.728 81.5667 33.0407 78.4293 33.0407ZM78.4293 43.3033C76.7107 43.3033 75.2293 41.7065 75.2293 39.4307C75.2293 37.131 76.712 35.5582 78.4293 35.5582C80.148 35.5582 81.6293 37.131 81.6293 39.4307C81.6307 41.705 80.148 43.3033 78.4293 43.3033ZM63.6587 35.0024V37.7123H69.416C69.244 39.237 68.7933 40.3501 68.1053 41.1237C67.268 42.067 65.9573 43.108 63.6587 43.108C60.1147 43.108 57.344 39.8889 57.344 35.8962C57.344 31.9035 60.1147 28.6845 63.6587 28.6845C65.5707 28.6845 66.9667 29.5317 67.9973 30.6207L69.6947 28.7085C68.2547 27.1598 66.344 25.9746 63.6587 25.9746C58.804 25.9746 54.7227 30.4269 54.7227 35.8962C54.7227 41.3655 58.804 45.8178 63.6587 45.8178C66.2787 45.8178 68.256 44.849 69.8013 43.0344C71.3907 41.2438 71.8853 38.7262 71.8853 36.6939C71.8853 36.066 71.8427 35.4846 71.756 35.0009H63.6587V35.0024ZM124.069 37.1069C123.597 35.6799 122.157 33.0407 119.215 33.0407C116.293 33.0407 113.865 35.6303 113.865 39.4292C113.865 43.0103 116.272 45.8178 119.493 45.8178C122.092 45.8178 123.596 44.0273 124.22 42.9863L122.287 41.5337C121.643 42.5987 120.761 43.3003 119.493 43.3003C118.227 43.3003 117.324 42.6468 116.744 41.364L124.327 37.831L124.069 37.1069ZM116.336 39.237C116.272 36.7675 118.033 35.5102 119.301 35.5102C120.289 35.5102 121.127 36.0675 121.407 36.8651L116.336 39.237ZM110.172 45.4318H112.663V26.6536H110.172V45.4318ZM106.089 34.4692H106.004C105.445 33.7181 104.371 33.0407 103.019 33.0407C100.183 33.0407 97.584 35.8482 97.584 39.4548C97.584 43.0359 100.183 45.8193 103.019 45.8193C104.372 45.8193 105.445 45.1419 106.004 44.3683H106.089V45.2876C106.089 47.7315 104.929 49.0384 103.061 49.0384C101.536 49.0384 100.591 47.8052 100.204 46.7642L98.0347 47.7811C98.6573 49.474 100.311 51.556 103.061 51.556C105.983 51.556 108.453 49.6197 108.453 44.9V33.4297H106.091V34.4692H106.089ZM103.233 43.3033C101.515 43.3033 100.076 41.6809 100.076 39.4548C100.076 37.2031 101.515 35.5582 103.233 35.5582C104.929 35.5582 106.261 37.2031 106.261 39.4548C106.261 41.6809 104.929 43.3033 103.233 43.3033ZM135.741 26.6536H129.78V45.4318H132.267V38.3177H135.74C138.497 38.3177 141.209 36.069 141.209 32.4864C141.209 28.9038 138.499 26.6536 135.741 26.6536ZM135.805 35.7039H132.267V29.2673H135.805C137.665 29.2673 138.721 31.0023 138.721 32.4864C138.721 33.9404 137.665 35.7039 135.805 35.7039ZM151.181 33.0076C149.38 33.0076 147.515 33.9014 146.743 35.8827L148.951 36.9207C149.423 35.8827 150.303 35.5432 151.224 35.5432C152.511 35.5432 153.819 36.413 153.84 37.9587V38.1524C153.389 37.8625 152.424 37.4284 151.245 37.4284C148.865 37.4284 146.441 38.902 146.441 41.6554C146.441 44.1685 148.393 45.7863 150.58 45.7863C152.252 45.7863 153.175 44.9406 153.753 43.9492H153.839V45.3987H156.241V38.199C156.243 34.8673 154.032 33.0076 151.181 33.0076ZM150.88 43.2987C150.067 43.2987 148.929 42.8391 148.929 41.7035C148.929 40.2539 150.345 39.6981 151.568 39.6981C152.66 39.6981 153.176 39.964 153.84 40.326C153.647 42.067 152.317 43.2987 150.88 43.2987ZM164.991 33.4177L162.139 41.5593H162.053L159.093 33.4177H156.413L160.852 44.7964L158.321 51.1264H160.916L167.757 33.4177H164.991ZM142.583 45.4318H145.069V26.6536H142.583V45.4318Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2241 15.7538C63.2241 17.0126 62.8934 18.0145 62.2307 18.7626C61.4787 19.6519 60.4974 20.0965 59.2921 20.0965C58.1374 20.0965 57.1547 19.6459 56.3481 18.7446C55.5401 17.8418 55.1361 16.7242 55.1361 15.3903C55.1361 14.0549 55.5401 12.9373 56.3481 12.036C57.1547 11.1333 58.1374 10.6826 59.2921 10.6826C59.8654 10.6826 60.4134 10.8088 60.9334 11.0597C61.4547 11.312 61.8721 11.647 62.1841 12.0661L61.4814 12.8592C60.9521 12.1457 60.2227 11.7897 59.2907 11.7897C58.4481 11.7897 57.7201 12.1232 57.1054 12.7901C56.4907 13.4571 56.1841 14.3238 56.1841 15.3888C56.1841 16.4538 56.4907 17.3206 57.1054 17.9875C57.7201 18.6545 58.4481 18.9879 59.2907 18.9879C60.1841 18.9879 60.9294 18.653 61.5254 17.9815C61.9121 17.5444 62.1361 16.936 62.1961 16.1564H59.2907V15.0734H63.1667C63.2067 15.3092 63.2241 15.536 63.2241 15.7538Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3709 11.9896H65.7282V14.8466H69.0135V15.9297H65.7282V18.7867H69.3709V19.8953H64.7002V10.8825H69.3709V11.9896Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7054 19.8953H72.6774V11.9896H70.4427V10.8825H75.94V11.9896H73.7054V19.8953Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9173 19.8953V10.8825H80.9453V19.8953H79.9173Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5042 19.8953H84.4762V11.9896H82.2415V10.8825H87.7389V11.9896H85.5042V19.8953Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1452 18.7311C97.3586 19.6414 96.3812 20.0966 95.2119 20.0966C94.0426 20.0966 93.0652 19.6414 92.2799 18.7311C91.4932 17.8208 91.1012 16.7063 91.1012 15.3889C91.1012 14.0715 91.4932 12.9569 92.2799 12.0466C93.0652 11.1363 94.0426 10.6797 95.2119 10.6797C96.3746 10.6797 97.3506 11.1378 98.1399 12.0526C98.9292 12.9674 99.3239 14.079 99.3239 15.3889C99.3239 16.7063 98.9306 17.8208 98.1452 18.7311ZM93.0386 17.9756C93.6306 18.6515 94.3546 18.988 95.2119 18.988C96.0692 18.988 96.7946 18.65 97.3852 17.9756C97.9772 17.2996 98.2746 16.4374 98.2746 15.3889C98.2746 14.3404 97.9772 13.4782 97.3852 12.8022C96.7946 12.1262 96.0692 11.7898 95.2119 11.7898C94.3546 11.7898 93.6306 12.1277 93.0386 12.8022C92.4479 13.4782 92.1506 14.3404 92.1506 15.3889C92.1506 16.4374 92.4479 17.2996 93.0386 17.9756Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.767 19.8953V10.8825H102.017L105.905 17.893H105.949L105.905 16.1565V10.8825H106.933V19.8953H105.86L101.792 12.5439H101.748L101.792 14.2803V19.8953H100.767Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2241 15.7538C63.2241 17.0126 62.8934 18.0145 62.2307 18.7626C61.4787 19.6519 60.4974 20.0965 59.2921 20.0965C58.1374 20.0965 57.1547 19.6459 56.3481 18.7446C55.5401 17.8418 55.1361 16.7242 55.1361 15.3903C55.1361 14.0549 55.5401 12.9373 56.3481 12.036C57.1547 11.1333 58.1374 10.6826 59.2921 10.6826C59.8654 10.6826 60.4134 10.8088 60.9334 11.0597C61.4547 11.312 61.8721 11.647 62.1841 12.0661L61.4814 12.8592C60.9521 12.1457 60.2227 11.7897 59.2907 11.7897C58.4481 11.7897 57.7201 12.1232 57.1054 12.7901C56.4907 13.4571 56.1841 14.3238 56.1841 15.3888C56.1841 16.4538 56.4907 17.3206 57.1054 17.9875C57.7201 18.6545 58.4481 18.9879 59.2907 18.9879C60.1841 18.9879 60.9294 18.653 61.5254 17.9815C61.9121 17.5444 62.1361 16.936 62.1961 16.1564H59.2907V15.0734H63.1667C63.2067 15.3092 63.2241 15.536 63.2241 15.7538Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3709 11.9896H65.7282V14.8466H69.0135V15.9297H65.7282V18.7867H69.3709V19.8953H64.7002V10.8825H69.3709V11.9896Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7054 19.8953H72.6774V11.9896H70.4427V10.8825H75.94V11.9896H73.7054V19.8953Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9173 19.8953V10.8825H80.9453V19.8953H79.9173Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5042 19.8953H84.4762V11.9896H82.2415V10.8825H87.7389V11.9896H85.5042V19.8953Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1452 18.7311C97.3586 19.6414 96.3812 20.0966 95.2119 20.0966C94.0426 20.0966 93.0652 19.6414 92.2799 18.7311C91.4932 17.8208 91.1012 16.7063 91.1012 15.3889C91.1012 14.0715 91.4932 12.9569 92.2799 12.0466C93.0652 11.1363 94.0426 10.6797 95.2119 10.6797C96.3746 10.6797 97.3506 11.1378 98.1399 12.0526C98.9292 12.9674 99.3239 14.079 99.3239 15.3889C99.3239 16.7063 98.9306 17.8208 98.1452 18.7311ZM93.0386 17.9756C93.6306 18.6515 94.3546 18.988 95.2119 18.988C96.0692 18.988 96.7946 18.65 97.3852 17.9756C97.9772 17.2996 98.2746 16.4374 98.2746 15.3889C98.2746 14.3404 97.9772 13.4782 97.3852 12.8022C96.7946 12.1262 96.0692 11.7898 95.2119 11.7898C94.3546 11.7898 93.6306 12.1277 93.0386 12.8022C92.4479 13.4782 92.1506 14.3404 92.1506 15.3889C92.1506 16.4374 92.4479 17.2996 93.0386 17.9756Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.767 19.8953V10.8825H102.017L105.905 17.893H105.949L105.905 16.1565V10.8825H106.933V19.8953H105.86L101.792 12.5439H101.748L101.792 14.2803V19.8953H100.767Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3833_18716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9147 11.6897C13.5267 12.1524 13.2973 12.8704 13.2973 13.8002V47.0215C13.2973 47.9528 13.5267 48.6693 13.9147 49.132L14.0133 49.2401L30.532 30.6302V30.4109V30.1915L14.0133 11.5801L13.9147 11.6897Z",
    fill: "url(#paint0_linear_3833_18716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0373 36.8361L30.532 30.6307V30.4114V30.1921L36.0386 23.9883L36.1627 24.0679L42.6866 28.2438C44.5493 29.4365 44.5493 31.3878 42.6866 32.582L36.1627 36.7579L36.0373 36.8361Z",
    fill: "url(#paint1_linear_3833_18716)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3833_18716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1627 36.7571L30.5307 30.4121L13.9147 49.1332C14.528 49.8663 15.5427 49.9564 16.6853 49.2264L36.1627 36.7571Z",
    fill: "url(#paint2_linear_3833_18716)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.1627 24.0663L16.6853 11.5986C15.5427 10.867 14.528 10.9587 13.9147 11.6917L30.532 30.4128L36.1627 24.0663Z",
    fill: "url(#paint3_linear_3833_18716)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5 1.36719H175V-0.632812H5V1.36719ZM179 5.36719V55.4526H181V5.36719H179ZM175 59.4526H5V61.4526H175V59.4526ZM1 55.4526V5.36719H-1V55.4526H1ZM5 59.4526C2.79086 59.4526 1 57.6618 1 55.4526H-1C-1 58.7663 1.68629 61.4526 5 61.4526V59.4526ZM179 55.4526C179 57.6618 177.209 59.4526 175 59.4526V61.4526C178.314 61.4526 181 58.7663 181 55.4526H179ZM175 1.36719C177.209 1.36719 179 3.15805 179 5.36719H181C181 2.05348 178.314 -0.632812 175 -0.632812V1.36719ZM5 -0.632812C1.68629 -0.632812 -1 2.05348 -1 5.36719H1C1 3.15805 2.79086 1.36719 5 1.36719V-0.632812Z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3833_18716",
    x: 13.2973,
    y: 11.0938,
    width: 30.7863,
    height: 38.6367,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3833_18716"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3833_18716",
    result: "effect2_innerShadow_3833_18716"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3833_18716",
    x: 13.9147,
    y: 30.4121,
    width: 22.248,
    height: 19.3184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3833_18716"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3833_18716",
    x1: 29.0678,
    y1: 13.4487,
    x2: 4.03696,
    y2: 35.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3833_18716",
    x1: 45.1113,
    y1: 30.4114,
    x2: 12.8501,
    y2: 30.4114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3833_18716",
    x1: 33.1041,
    y1: 33.8579,
    x2: -0.840751,
    y2: 63.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3833_18716",
    x1: 9.72987,
    y1: 0.632686,
    x2: 24.8872,
    y2: 14.0867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.a0a7c5a8453b82290f1c4fbb0f64e26e.svg";
export { ForwardRef as ReactComponent };